import React, { useEffect, useState, useMemo } from "react";
import SectionHeader from "../../components/sectionHeader/sectionHeader";
import Card from "../../components/card/card";
import { getApiInstance } from "../../utils/api";
import "./mobiliarioCentral.scss";
import InputSearch from "../../components/inputs/inputSearch/inputSearch";
import Button from "../../components/button/button";
import { IoReloadOutline } from "react-icons/io5";
import { searchByKeywords } from "../../utils/searchUtils";
import { useParams, useSearchParams } from "react-router-dom";


export default function MobiliarioCentral() {
    const { subcategoria } = useParams();
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [visibleCount, setVisibleCount] = useState(15);
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchTerm, setSearchTerm] = useState("");
    const [allProducts, setAllProducts] = useState([]);
    const [allGlobal, setAllGlobal] = useState(null);
    const [loadingGlobal, setLoadingGlobal] = useState(false);

    useEffect(() => {
  const loadAll = async () => {
    if (!searchTerm || allGlobal) return;        // ya cargado o no hace falta
    try {
      setLoadingGlobal(true);
      const api = getApiInstance();
      // Usa tu endpoint global. Si no lo tienes, usa GetAllMuebles o concatena por familias.
      const res = await api.get('/api/Mueble/GetMueblesCatalogo');
      setAllGlobal(res.data);
    } catch (e) {
      console.error('Error cargando catálogo global', e);
    } finally {
      setLoadingGlobal(false);
    }
  };
  loadAll();
}, [searchTerm, allGlobal]);


    useEffect(() => {
    const term = searchParams.get("q") || "";
    setSearchTerm(term);
}, [searchParams]);



const visibleProducts = useMemo(() => {
    if (!searchTerm) return products;
    const base = allGlobal ?? products;
    return searchByKeywords(base, searchTerm, [
        "referencia",
        "nombreBook",
        "nombreFamilia"
    ]);
}, [products, searchTerm, allGlobal]);


    const subcategoriaCodigos = {
        // general: [4],
        // "tiendas-top": [1],
        // "tiendas-light": [2],
        // "tiendas-low": [3],
        munich: [9],
        copenhague: [10],
        miami: [11],
        "make-up-400": [8],
        todo: [],
    };

    // Mapeo de códigos de categoría a nombres descriptivos
    const categoriasMap = {
        8: "Make Up 400",
        9: "Munich",
        10: "Copenhague", 
        11: "Miami-Splau"
    };

    useEffect(() => {
        fetchProducts(subcategoria);
    }, [subcategoria]);

    const fetchProducts = async (subcategoriaKey) => {
        setLoading(true);
        const api = getApiInstance();
        const codsCategoria = subcategoriaCodigos[subcategoriaKey] || [];

        try {
            let productsData = [];

            if (subcategoriaKey === "todo") {
                const response = await api.get(
                    `/api/Mueble/GetMueblesByFamilia/1`
                );
                productsData = response.data;
            } else {
                const endpointBase = `/api/Mueble/GetMueblesByFamiliaCategoria?codFamilia=1&codCategoria=`;
                const promises = codsCategoria.map((cod) =>
                    api.get(`${endpointBase}${cod}`).catch((err) => {
                        console.error(`Error fetching category ${cod}:`, err);
                        return null;
                    })
                );
                const responses = await Promise.all(promises);
                productsData = responses.flatMap((response) =>
                    response ? response.data : []
                );
            }

            setProducts(productsData);
            setAllProducts(productsData); 
            setFilteredProducts(productsData);
            setVisibleCount(15);
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar los muebles. Vuelve a intentarlo más tarde."
            );
            setProducts([]);
            setFilteredProducts([]);
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

const handleSearch = (term) => {
      setVisibleCount(15);

    setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        if (term) {
            newParams.set("q", term);
        } else {
            newParams.delete("q");
        }
        return newParams;
    });
};


    if (loading)
        return (
            <div className="muebles-pages__error-message">
                Cargando muebles...
            </div>
        );

    if (error)
        return (
            <div className="muebles-pages__error-message">Error: {error}</div>
        );
    

    return (
        <div className="mobiliario-central">
            <SectionHeader title={`Mobiliario Central - ${subcategoria}`} />

            <div className="mobiliario-central__header">
                <div className="mobiliario-central__header__search">
                    <InputSearch
                        context="tableSearch"
                        value={searchTerm}
                        onSearch={handleSearch}
                        placeholder="Buscar productos..."
                    />
                </div>
            </div>

            <div className="mobiliario-central__cards">
                {visibleProducts.length > 0 ? (
                    <>
                        {visibleProducts
                            .slice(0, visibleCount)
                            .map((product) => (
                                <Card
                                    key={product.codMueble}
                                    title={product.nombreBook}
                                    subtitle={product.nombreFamilia}
                                    reference={product.referencia}
                                    codCategoria={
                                        // Primera opción: si tiene codCategorias (números), mapear a nombres
                                        product.codCategorias && product.codCategorias.length > 0 
                                            ? product.codCategorias.map(codigo => categoriasMap[codigo] || codigo).join(", ")
                                            // Segunda opción: si tiene categorias (strings), usar directamente
                                            : product.categorias && product.categorias.length > 0
                                                ? product.categorias.join(", ")
                                                : null
                                    }
                                    image={product.rutaImagen}
                                    link={`/ficha-producto/${product.codMueble}`}
                                    pendienteAprobacion={
                                        product.pendienteDeAprobacion
                                    }
                                    showButton={true}
                                />
                            ))}

                        {visibleCount < visibleProducts.length && (
                            <div className="mobiliario-central__load-more-container">
                                <Button
                                    label="Cargar más"
                                    variant="filled"
                                    icon={<IoReloadOutline />}
                                    onClick={() =>
                                        setVisibleCount((prev) => prev + 15)
                                    }
                                />
                            </div>
                        )}
                    </>
                ) : (
                    <p className="mobiliario-central__cards__no-results-message">
                        No hay muebles en esta categoría
                    </p>
                )}
            </div>
        </div>
    );
}
